const shareholderIdentityDatashape = `
  ... on ShareholderNationalIdType {
    type
    idFrontImage
    idBackImage
  }
  ... on ShareholderPassportType {
    type
    passportAttachment
  }
`;
export default shareholderIdentityDatashape;
